import { Shortcut } from './Shortcut';
// Maps the shortcut to its accelerator string, see: https://www.electronjs.org/docs/latest/api/accelerator
// Note: Users can configure custom shortcuts that override these default accelerators
export const SHORTCUT_DEFAULTS = new Map([
    [Shortcut.PlayPause, 'CommandOrControl+/'],
    [Shortcut.IncreasePlaybackSpeed, 'CommandOrControl+Shift+Up'],
    [Shortcut.DecreasePlaybackSpeed, 'CommandOrControl+Shift+Down'],
    [Shortcut.SeekForward5, 'CommandOrControl+Shift+Right'],
    [Shortcut.SeekBackwards5, 'CommandOrControl+Shift+Left'],
    [Shortcut.SeekToEnd, 'CommandOrControl+Shift+.'],
    [Shortcut.IncreaseVolume, 'CommandOrControl+Up'],
    [Shortcut.DecreaseVolume, 'CommandOrControl+Down'],
    [Shortcut.ToggleMute, 'CommandOrControl+Left'],
    [Shortcut.SelectPlaybackTime, 'CommandOrControl+Shift+P'],
    [Shortcut.SelectPlayhead, 'CommandOrControl+Shift+W'],
    [Shortcut.TurnAllChannelsOn, 'CommandOrControl+0'],
    [Shortcut.ToggleChannelsPanel, 'CommandOrControl+Shift+C'],
    [Shortcut.SoloChannelOne, 'CommandOrControl+1'],
    [Shortcut.SoloChannelTwo, 'CommandOrControl+2'],
    [Shortcut.SoloChannelThree, 'CommandOrControl+3'],
    [Shortcut.SoloChannelFour, 'CommandOrControl+4'],
    [Shortcut.SoloChannelFive, 'CommandOrControl+5'],
    [Shortcut.SoloChannelSix, 'CommandOrControl+6'],
    [Shortcut.SoloChannelSeven, 'CommandOrControl+7'],
    [Shortcut.SoloChannelEight, 'CommandOrControl+8'],
    [Shortcut.SoloChannelNine, 'CommandOrControl+Shift+1'],
    [Shortcut.SoloChannelTen, 'CommandOrControl+Shift+2'],
    [Shortcut.SoloChannelEleven, 'CommandOrControl+Shift+3'],
    [Shortcut.SoloChannelTwelve, 'CommandOrControl+Shift+4'],
    [Shortcut.SoloChannelThirteen, 'CommandOrControl+Shift+5'],
    [Shortcut.SoloChannelFourteen, 'CommandOrControl+Shift+6'],
    [Shortcut.SoloChannelFifteen, 'CommandOrControl+Shift+7'],
    [Shortcut.SoloChannelSixteen, 'CommandOrControl+Shift+8'],
]);
